//React
import React, { useEffect, useState } from "react";
import Metrics from "../../components/dashboard/metrics";
import PageViewTrend from "../../components/dashboard/pageViewTrend";
import TopAudiences from "../../components/manager/audienceRow";
import { getSession } from "../../services/auth";
// CSS
import "./index.scss";

/**
 * AMS Console. The Daily Trend card charts page views and unique users per day
 * (ASB-3567); page views there replace the Page Views and SPA / AMP / API
 * Requests lines the ArcSpan Processor card used to carry.
 */
function Home() {
	const [publisherSettings, setPublisherSettings] = useState(localStorage.getItem("publisherSettings"));
	const [amsFlavor, setAmsFlavor] = useState("");

	const verifyAccess = async () => {
		const session = getSession();
		if (!session) return;

		const settings = await JSON.parse(publisherSettings) ?? {};
		let amsFlavorValue = settings.ams_flavor ?? "full";
		setAmsFlavor(amsFlavorValue);
	};

	useEffect(() => {
		window.addEventListener("storage", () => {
			setPublisherSettings(localStorage.getItem("publisherSettings"));
		});
		document.title = "Dashboard";
	}, []);

	useEffect(() => {
		verifyAccess();
	}, [publisherSettings]);

	return (
		<div className="wrapper">
			<div className="top-fold">
				<div className="container">
					<div className="container--inner">
						<h1 className="caps">
							AMS {amsFlavor === "contextual" ? "Contextual Console" : "Console"}
						</h1>
						<div className="dashboard-container">
							<Metrics />
							<PageViewTrend />
						</div>
					</div>
				</div>
			</div>
			<div className="bottom-fold">
				<div className="container">
					<div className="container--inner">
						<div className="audiences">
							<div className="headings">
								<p className="p2 strong">Top Auto-Generated Audiences</p>
								<p className="p4">Top Audience (Unique Users)</p>
							</div>
							<TopAudiences />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Home;
